import { combineReducers } from "redux";

import Home from "./home/reducer";

const rootReducer = combineReducers({
  Home
});

export default rootReducer;
